<template>
  <div class="inicio">
    <h1>Información del plan</h1>
  </div>
</template>

<script>
  import sha1 from 'js-sha1'
  import md5 from 'blueimp-md5'
  import Snackbar from 'node-snackbar'
  export default {
    name: 'inicio',
    beforeCreate(){
      if (!this.$session.exists()) {
        this.$router.push('/login')
      }
    },
    data(){
      return {
        msg: 'Inicio'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// PlanesDetalle.vue?5be3865c